import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import type { Address } from "viem";

export interface SelectedNFT {
  id: string;
  contractAddress: Address;
  tokenId: string;
  collectionName: string;
  image?: string;
  name?: string;
}

// Atom for storing selected NFTs for bulk transfer
export const selectedNFTsAtom = atom<SelectedNFT[]>([]);

// Atom for bulk transfer modal state
export const bulkTransferModalAtom = atom<boolean>(false);

// Atom for recent mantra listings modal state
export const mantraListingsModalAtom = atom<{
  isOpen: boolean;
  collectionAddress?: Address;
}>({
  isOpen: false,
  collectionAddress: undefined,
});